import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Immutable from 'immutable';
import { push } from 'react-router-redux';
import { changeItineraryIdBookingRoadBooking, changeStepRoadBooking, clearRoadBookingDiscount, clearRoadBookingSoldSeats, getSearchItineraryRoadBooking } from '../../../../actions';
import Loader from '../../../common/Loader';
import RoadBookingItineraryCard from './RoadBookingItineraryCard';
import { CIVA_ROAD_BOOKING_SELECTION_SEAT_STEP_INDEX, CIVA_ROAD_BOOKING_STEPS } from '../../../../config/constants';

const RoadBookingSearchResult = ({ itineraryList, loading, sourceCityOrigin, dispatchChangeItineraryIdBookingRoadBooking, itineraryIdSelected, dispatchClearRoadBookingDiscount, dispatchClearRoadBookingSoldSeats, loadingSalesSession, dispatchChangeStepRoadBooking }) => {

  const handleItineraryClick = (element) => {
    dispatchChangeItineraryIdBookingRoadBooking(element.itineraryId);
    dispatchChangeStepRoadBooking(CIVA_ROAD_BOOKING_STEPS[CIVA_ROAD_BOOKING_SELECTION_SEAT_STEP_INDEX]);
    dispatchClearRoadBookingDiscount();
    dispatchClearRoadBookingSoldSeats();
  }

  let content = null;

  if (loading || loadingSalesSession) {
    content = <Loader />
  }
  else if (itineraryList.isEmpty()) {
    content = <p>No hay itinerarios disponibles.</p>
  }
  else if (itineraryList.size > 0) {
    let itineraryItems = []
    if (sourceCityOrigin) {
      itineraryItems = itineraryList.filter((itinerary) => itinerary.destination.cityId === sourceCityOrigin).toArray()
    } else {
      itineraryItems = itineraryList.toArray()
    }
    content = (<ul className='p-0'>
      {itineraryItems.map((itinerary) => (
        <RoadBookingItineraryCard key={itinerary.itineraryId} itinerary={itinerary} onClick={handleItineraryClick} itineraryIdSelected={itineraryIdSelected} />
      ))}
    </ul>)
  }

  return (
    <div>
      {content}
    </div>
  )
}

RoadBookingSearchResult.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    securityProfileSet: PropTypes.arrayOf(
      PropTypes.shape({
        viewAuthorizationList: PropTypes.arrayOf(
          PropTypes.shape({
            view: PropTypes.shape({
              route: PropTypes.string,
            }),
          }),
        ).isRequired,
      }),
    ).isRequired,
    salesSessionUserId: PropTypes.number,
  }).isRequired,
  itineraryList: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool.isRequired,
  sourceCityOrigin: PropTypes.number,
  dispatchChangeStepRoadBooking: PropTypes.func.isRequired,
  dispatchChangeItineraryIdBookingRoadBooking: PropTypes.func.isRequired,
  itineraryIdSelected: PropTypes.number,
  dispatchClearRoadBookingDiscount: PropTypes.func.isRequired,
  dispatchClearRoadBookingSoldSeats: PropTypes.func.isRequired,
  loadingSalesSession: PropTypes.bool,
}

RoadBookingSearchResult.defaultProps = {
  sourceCityOrigin: null,
  itineraryIdSelected: null,
  loadingSalesSession: false,
}

const mapStateToProps = ({ authentication, SalesUnit, BookingUnit }) => ({
  user: authentication.get('user'),
  currentSession: SalesUnit.SalesSession.getIn(['active', 'content']),
  sourceCityOrigin: BookingUnit.Booking.getIn(['roadBooking', 'sourceCityOrigin']),
  itineraryList: BookingUnit.Booking.getIn(['roadBooking', 'searchResults']),
  loading: BookingUnit.Booking.getIn(['roadBooking', 'loading']),
  itineraryIdSelected: BookingUnit.Booking.getIn(['roadBooking', 'itineraryId']),
  loadingSalesSession: SalesUnit.SalesSession.getIn(['active', 'loading']),
})

const mapDispatchToProps = {
  dispatchGetSearchItineraryRoadBooking: getSearchItineraryRoadBooking,
  dispatchChangeStepRoadBooking: changeStepRoadBooking,
  dispatchChangeItineraryIdBookingRoadBooking: changeItineraryIdBookingRoadBooking,
  dispatchPush: push,
  dispatchClearRoadBookingDiscount: clearRoadBookingDiscount,
  dispatchClearRoadBookingSoldSeats: clearRoadBookingSoldSeats,
}

export default connect(mapStateToProps, mapDispatchToProps)(RoadBookingSearchResult)
